/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  /* eslint-disable */

  window.PXUTheme.jsAjaxCart = {
    init: function ($section) {
      // Add settings from schema to current object
      window.PXUTheme.jsAjaxCart = $.extend(
          this,
          window.PXUTheme.getSectionData($section)
      );

      if (isScreenSizeLarge() || this.cart_action == "drawer") {
        this.initializeAjaxCart();
      } else {
        this.initializeAjaxCartOnMobile();
      }

      if (this.cart_action == "drawer") {
        this.ajaxCartDrawer = $("[data-ajax-cart-drawer]");

        $(document).on("click", "[data-ajax-cart-trigger]", function (e) {
          e.preventDefault();
          window.PXUTheme.jsAjaxCart.showDrawer();

          return false;
        });
      } else if (this.cart_action == "mini_cart") {
        this.showMiniCartOnHover();
      }

      // Handle pre-order validation for non-ajax cart actions
      if (this.cart_action !== "mini_cart" && this.cart_action !== "drawer") {
        $(document).on(
            "click",
            ".button--add-to-cart, [data-add-to-cart-trigger], .action_button--secondary",
            function (e) {
              const $form = $(this).closest("form");

              // Check pre-order cart restrictions before proceeding
              if (window.PXUTheme.jsPreOrderCart) {
                const productHandle =
                    window.PXUTheme.jsPreOrderCart.getProductHandle($form);
                const isPreOrderProduct =
                    window.PXUTheme.jsPreOrderCart.isPreOrderProduct(productHandle);

                if (
                    !window.PXUTheme.jsPreOrderCart.validateCartAddition(
                        isPreOrderProduct,
                        productHandle
                    )
                ) {
                  e.preventDefault();
                  e.stopPropagation();

                  // Show modal on single product pages instead of blocking
                  if (window.location.pathname.includes("/products/")) {
                    const message =
                        window.PXUTheme.translation.preOrderSingleOnly;
                    window.PXUTheme.jsPreOrderCart.showModal(message);
                  }

                  return false;
                }
              }
            }
        );

        // Also intercept form submissions for reload_page action
        if (this.cart_action === "reload_page") {
          $(document).on("submit", 'form[action*="/cart/add"]', function (e) {
            const $form = $(this);
            console.log("Direct form submit intercepted:", $form.serialize());

            // Check pre-order cart restrictions before proceeding
            if (window.PXUTheme.jsPreOrderCart) {
              const productHandle =
                  window.PXUTheme.jsPreOrderCart.getProductHandle($form);
              const isPreOrderProduct =
                  window.PXUTheme.jsPreOrderCart.isPreOrderProduct(productHandle);

              if (
                  !window.PXUTheme.jsPreOrderCart.validateCartAddition(
                      isPreOrderProduct,
                      productHandle
                  )
              ) {
                e.preventDefault();

                // Show modal on single product pages instead of blocking
                if (window.location.pathname.includes("/products/")) {
                  const message =
                      window.PXUTheme.translation.preOrderSingleOnly;
                  window.PXUTheme.jsPreOrderCart.showModal(message);
                }

                return false;
              }
            }
          });

          // Initial cart check for reload_page action (only once)
          if (
              window.PXUTheme.jsPreOrderCart &&
              !window.PXUTheme.jsPreOrderCart.initialCheckDone
          ) {
            window.PXUTheme.jsPreOrderCart.initialCheckDone = true;
            setTimeout(() => {
              window.PXUTheme.jsPreOrderCart.checkCartOnLoad();
            }, 1000);
          }
        }
      }

      $(document).on("click", ".ajax-submit", function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest("form");
        console.log("AJAX submit clicked - form found:", $addToCartForm.length);

        // Check pre-order cart restrictions before proceeding
        if (window.PXUTheme.jsPreOrderCart) {
          const productHandle =
              window.PXUTheme.jsPreOrderCart.getProductHandle($addToCartForm);
          const isPreOrderProduct =
              window.PXUTheme.jsPreOrderCart.isPreOrderProduct(productHandle);

          if (
              !window.PXUTheme.jsPreOrderCart.validateCartAddition(
                  isPreOrderProduct,
                  productHandle
              )
          ) {
            // Show modal on single product pages instead of blocking
            if (window.location.pathname.includes("/products/")) {
              const message = window.PXUTheme.translation.preOrderSingleOnly;
              window.PXUTheme.jsPreOrderCart.showModal(message);
            }

            return false;
          }
        }

        window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

        return false;
      });

      $(document).on("click", "[data-ajax-cart-delete]", function (e) {
        e.preventDefault();
        const lineID = $(this).parents("[data-line-item]").data("line-item");
        const itemKey = $(this).data("cart-item-key");
        window.PXUTheme.jsAjaxCart.removeFromCart(lineID, itemKey);

        return false;
      });

      $(document).on("click", "[data-ajax-cart-close]", function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.hideDrawer();
        window.PXUTheme.jsAjaxCart.hideMiniCart();

        return false;
      });

      // Global form submission interceptor for debugging
      $(document).on("submit", 'form[action*="/cart/add"]', function (e) {
        console.log("=== FORM SUBMISSION DEBUG ===");
        console.log("Form action:", $(this).attr("action"));
        console.log("Form data:", $(this).serialize());
        console.log(
            "Form elements:",
            $(this).find("input, select").serializeArray()
        );

        const $variantInput = $(this).find(
            'input[name="id"], select[name="id"]'
        );
        console.log("Variant input found:", $variantInput.length);
        console.log("Variant input value:", $variantInput.val());

        const $productIdInput = $(this).find(
            'input[name="product-id"], select[name="product-id"]'
        );
        console.log("Product-id input found:", $productIdInput.length);
        if ($productIdInput.length) {
          console.log("Product-id input value:", $productIdInput.val());
        }

        // Check if variant is properly selected
        if (!$variantInput.val() || $variantInput.val() === "not-selected") {
          console.log("WARNING: No valid variant selected!");
          // Try to auto-select first available variant
          const $firstVariant = $(this)
              .find(
                  'select[name="id"] option:not([disabled]):not([value="not-selected"])'
              )
              .first();
          if ($firstVariant.length) {
            console.log("Auto-selecting variant:", $firstVariant.val());
            $variantInput.val($firstVariant.val());
          }
        }

        console.log("=== END FORM DEBUG ===");
      });
    },
    showMiniCartOnHover: function () {
      const $el = $("[data-ajax-cart-trigger]");

      $el.hover(
          function () {
            if (
                window.PXUTheme.theme_settings.header_layout == "centered" &&
                $(".header-sticky-wrapper").hasClass("is-sticky")
            ) {
              $(".header-sticky-wrapper [data-ajax-cart-trigger]").addClass(
                  "show-mini-cart"
              );
            } else {
              $el.addClass("show-mini-cart");
            }
          },
          function () {
            $el.removeClass("show-mini-cart");
          }
      );
    },
    hideMiniCart: function () {
      if (this.cart_action != "mini_cart") return false;
      const $el = $("[data-ajax-cart-close]").parents(
          "[data-ajax-cart-trigger]"
      );
      $el.removeClass("show-mini-cart");
    },
    toggleMiniCart: function () {
      const $el = $(".mobile-header [data-ajax-cart-trigger]");

      // Removes url to the cart page so user is not redirected
      $el.attr("href", "#");

      $el.off("touchstart").on("touchstart", function (e) {
        // If user clicks inside the element, do nothing
        if (e.target.closest("[data-ajax-cart-mini_cart]")) {
          return;
        }

        // Loads content into ajaxCart container for mobile header
        window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

        // If user clicks outside the element, toggle the mini cart
        $el.toggleClass("show-mini-cart");
      });
    },
    showDrawer: function () {
      if (this.cart_action != "drawer") return false;
      this.ajaxCartDrawer.addClass("is-visible");
      $(".ajax-cart__overlay").addClass("is-visible");
    },
    hideDrawer: function () {
      if (this.cart_action != "drawer") return false;
      this.ajaxCartDrawer.removeClass("is-visible");
      $(".ajax-cart__overlay").removeClass("is-visible");
    },
    removeFromCart: function (lineID, itemKey, callback) {
      const updates = {};
      updates[itemKey || lineID] = 0;
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          window.PXUTheme.jsAjaxCart.updateView();

          // Update pre-order cart restrictions after removal
          if (window.PXUTheme.jsPreOrderCart) {
            window.PXUTheme.jsPreOrderCart.checkCartOnLoad();
          }
        })
        .catch(function () {});
    },
    initializeAjaxCart: function () {
      window.PXUTheme.asyncView
          .load(
              window.PXUTheme.routes.cart_url, // template name
              "ajax" // view name (suffix)
          )
          .done(({ html, options }) => {
            $("[data-ajax-cart-content]").html(html.content);

            // Converting the currencies
            if (window.PXUTheme.currencyConverter) {
              window.PXUTheme.currencyConverter.convertCurrencies();
            }
          })
          .fail(() => {
            // some error handling
          });
    },
    initializeAjaxCartOnMobile: function () {
      this.toggleMiniCart();

      window.PXUTheme.asyncView
          .load(
              window.PXUTheme.routes.cart_url, // template name
              "ajax" // view name (suffix)
          )
          .done(({ html, options }) => {
            $(".mobile-header [data-ajax-cart-content]").html(html.content);
          })
          .fail(() => {
            // some error handling
          });
    },
    addToCart: function ($addToCartForm) {
      const $addToCartBtn = $addToCartForm.find(".button--add-to-cart");
      this.recipientForm = $addToCartForm[0].querySelector(
          "[data-recipient-form]"
      );

      if (this.recipientForm) {
        this.recipientForm.classList.remove("recipient-form--has-errors");
      }

      $addToCartForm.removeClass("shopify-product-form--unselected-error");

      if ($addToCartBtn[0].hasAttribute("data-options-unselected")) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

        $(".warning").remove();

        $addToCartForm
            .addClass("shopify-product-form--unselected-error")
            .find(".cart-warning")
            .html(cartWarning);

        $addToCartBtn.removeAttr("disabled").removeClass("disabled");

        $addToCartBtn.find(".icon").removeClass("zoomOut").addClass("zoomIn");

        $addToCartBtn
            .find("span:not(.icon)")
            .text($addToCartBtn.data("label"))
            .removeClass("zoomOut")
            .addClass("zoomIn");
      } else {
        // Debug: Log the form data being sent
        const formData = $addToCartForm.serialize();
        console.log("Add to cart payload:", formData);
        console.log(
            "Form elements:",
            $addToCartForm.find("input, select").serializeArray()
        );

        // Debug: Check variant selection specifically
        const $variantInput = $addToCartForm.find(
            'input[name="id"], select[name="id"]'
        );
        console.log("Variant input found:", $variantInput.length);
        console.log("Variant input value:", $variantInput.val());
        console.log("Variant input name:", $variantInput.attr("name"));

        // Debug: Check for any product-id fields
        const $productIdInput = $addToCartForm.find(
            'input[name="product-id"], select[name="product-id"]'
        );
        console.log("Product-id input found:", $productIdInput.length);
        if ($productIdInput.length) {
          console.log("Product-id input value:", $productIdInput.val());
        }

        $.ajax({
          url: "/cart/add.js",
          dataType: "json",
          cache: false,
          type: "post",
          data: formData,
          beforeSend: function () {
            $addToCartBtn.attr("disabled", "disabled").addClass("disabled");

            $addToCartBtn
                .find("span")
                .removeClass("fadeInDown")
                .addClass("animated zoomOut");
          },
          success: function (product) {
            let $el = $("[data-ajax-cart-trigger]");

            $addToCartBtn.find(".checkmark").addClass("checkmark-active");

            function addedToCart() {
              if (!isScreenSizeLarge()) {
                $el = $(".mobile-header [data-ajax-cart-trigger]");
                window.PXUTheme.scrollToTop($el);
              } else {
                $el = $("[data-ajax-cart-trigger]");
              }

              $el.addClass("show-mini-cart");

              $addToCartBtn.find("span").removeClass("fadeInDown");
            }

            window.setTimeout(function () {
              $addToCartBtn.removeAttr("disabled").removeClass("disabled");

              $addToCartBtn.find(".checkmark").removeClass("checkmark-active");

              $addToCartBtn
                  .find(".text, .icon")
                  .removeClass("zoomOut")
                  .addClass("fadeInDown");

              $addToCartBtn.on(
                  "webkitAnimationEnd oanimationend msAnimationEnd animationend",
                  addedToCart
              );
            }, 1000);

            window.PXUTheme.jsAjaxCart.showDrawer();
            window.PXUTheme.jsAjaxCart.updateView();

            // Update pre-order cart restrictions after successful addition
            if (window.PXUTheme.jsPreOrderCart) {
              window.PXUTheme.jsPreOrderCart.checkCartOnLoad();
            }

            if (window.PXUTheme.jsCart) {
              $.ajax({
                dataType: "json",
                async: false,
                cache: false,
                dataType: "html",
                url: "/cart",
                success: function (html) {
                  const cartForm = $(html).find(".cart__form");
                  $(".cart__form").replaceWith(cartForm);
                },
              });
            }
          },
          error: (XMLHttpRequest) => {
            console.log(
                "Cart add error response:",
                XMLHttpRequest.responseText
            );
            console.log("Cart add error status:", XMLHttpRequest.status);
            console.log(
                "Cart add error statusText:",
                XMLHttpRequest.statusText
            );

            const response = eval("(" + XMLHttpRequest.responseText + ")");

            $(".warning").remove();

            let cartWarning;

            if (response.errors && response.errors.email) {
              this.recipientForm.classList.add("recipient-form--has-errors");
            } else {
              cartWarning = `<p class="cart-warning__message animated bounceIn">${response.description.replace(
                  "All 1 ",
                  "All "
              )}</p>`;
            }

            $addToCartForm.find(".cart-warning").html(cartWarning);

            $addToCartBtn.removeAttr("disabled").removeClass("disabled");

            $addToCartBtn
                .find(".icon")
                .removeClass("zoomOut")
                .addClass("zoomIn");

            $addToCartBtn
                .find("span:not(.icon)")
                .text($addToCartBtn.data("label"))
                .removeClass("zoomOut")
                .addClass("zoomIn");
          },
        });
      }
    },
    updateView: function () {
      window.PXUTheme.asyncView
          .load(
              window.PXUTheme.routes.cart_url, // template name
              "ajax" // view name (suffix)
          )
          .done(({ html, options }) => {
            if (options.item_count > 0) {
              const itemList = $(html.content).find(".ajax-cart__list");
              const cartDetails = $(html.content).find(
                  ".ajax-cart__details-wrapper"
              );

              $(".ajax-cart__list").replaceWith(itemList);
              $(".ajax-cart__details-wrapper").replaceWith(cartDetails);
              $(".ajax-cart__empty-cart-message").addClass("is-hidden");
              $(".ajax-cart__form").removeClass("is-hidden");
              $("[data-ajax-cart-trigger]").addClass("has-cart-count");
              $('[data-bind="itemCount"]').text(options.item_count);
            } else {
              $(".ajax-cart__empty-cart-message").removeClass("is-hidden");
              $(".ajax-cart__form").addClass("is-hidden");
              $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
              $('[data-bind="itemCount"]').text("0");
            }

            if (window.PXUTheme.currencyConverter) {
              window.PXUTheme.currencyConverter.convertCurrencies();
            }
          })
          .fail(() => {
            // some error handling
          });
    },
    unload: function ($section) {
      // Clear event listeners in theme editor
      $(".ajax-submit").off();
      $("[data-ajax-cart-delete]").off();
    },
  };

  /******/
})();
